<div class="social-share-wrap margin-bottom-30; padding-bottom-30">
    <ul class="social-media-list" style="padding-left: 0">
        <li>
            <div class="fb-share-button" data-layout="button" data-size="large" data-mobile-iframe="true">
                <a rel="noopener" class="btn btn-icon btn-facebook" target="_blank"
                    href="https://www.facebook.com/sharer/sharer.php?u={{getTheUrl()}}&amp;src=sdkpreparse"><i
                        class="fa fa-facebook left"></i>&nbsp;Share</a>
            </div>
        </li>
        <li>
            <a rel="noopener" href="https://twitter.com/share?url={{getTheUrl()}}" target="_blank" class="btn btn-icon"
                data-size="large" data-show-count=" false">
                <i class="fa fa-twitter"></i>&nbsp;Tweet</a>
        </li>
    </ul>
</div>